import { render, staticRenderFns } from "./manufacture.vue?vue&type=template&id=9a2e8fe0&"
import script from "./manufacture.vue?vue&type=script&lang=js&"
export * from "./manufacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports